import 'foundation-sites'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import { KajikiData } from '../../store/manager/state'
import { formatPublishSiteStatus } from './Formatter'
import { Getters } from '../../store/manager/helpers'

@Component({})
export default class ContentsHeader extends Vue {
  name: 'ContentsHeader'
  $store: Store<RootState>
  aquariumLoginUrl: string = process.env.AQUARIUM_LOGIN_URL

  get getKajikiData(): KajikiData[] {
    return this.$store.state.manager.kajikiData
  }

  get getUserName(): string {
    return Getters.getAcountData(this.$store).userName
  }

  get siteId(): number {
    return Getters.getAcountData(this.$store).kajikiId
  }

  set siteId(siteId: number) {
    this.$router.push({
      name: this.$route.name,
      params: Object.assign({}, this.$route.params, {
        kajiki_id: siteId.toString()
      })
    })
  }

  formatPublishSiteStatus(status: boolean): string {
    return formatPublishSiteStatus(status)
  }
}
